import { useSelector } from 'react-redux'
import FullWidthGridGallery from './FullWidthGridGallery'
import GridViewGallery from './GridViewGallery'
import GridWideGutterGallery from './GridWideGutterGallery'
import ListViewGallery from './ListViewGallery'
import MasonryGutterGallery from './MasonryGutterGallery'
import MasonryShowcaseGallery from './MasonryShowcaseGallery'

function GalleryWrapper() {

    const sitedata = useSelector((store) => store.global.loginData);
    return (
        <>


            {sitedata?.theme_gallery === "masonry-showcase" ? (
                <MasonryShowcaseGallery />
            ) : sitedata?.theme_gallery === "grid" ? (
                <GridViewGallery />
            ) : sitedata?.theme_gallery === "grid-full-width" ? (
                <FullWidthGridGallery />
            ) : sitedata?.theme_gallery === "grid-wide-gutter" ? (
                <GridWideGutterGallery />
            ) : sitedata?.theme_gallery === "list" ? (
                <ListViewGallery />
            ) : sitedata?.theme_gallery === "masonry-gutter" ? (
                <MasonryGutterGallery />
            ) : (
                <GridViewGallery />
            )}


        </>
    )
}

export default GalleryWrapper